import styled from "styled-components/macro";
import InfiniteScroll from "react-infinite-scroll-component";

import "./index.scss";
import Spin from "antd/lib/spin";
import Popover from "antd/lib/popover";
import MarkRead from "assets/icons/LayoutVer3/MarkReaded.svg";
import Clock from "assets/icons/LayoutVer3/clock_outline.svg";
import parse from "html-react-parser";
import { optionsParse } from "util/staticData";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import NotificationIcon from "components/Icon/NotificationIcon";

function NotificationVer3({
  showNoti,
  handleShowNoti,
  onClickNoti,
  listNoti,
  loadMoreNoti,
  hasMoreNoti,
  handleShowMenuNoti,
  showMenuNoti,
  onOpenNotifications,
  onMarkAllRead,
  isLoading,
  unseenNoti,
}) {
  const { t } = useTranslation();

  return (
    <Popover
      content={
        <WrapperNoti isLoading={isLoading}>
          {isLoading ? (
            <Spin />
          ) : (
            <>
              {listNoti.length === 0 ? (
                <EmptyNoti>No notification</EmptyNoti>
              ) : (
                <EarlierNoti>
                  <div
                    style={{
                      background: "#fff",
                      height: "16px",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  />
                  <WrapTitle>
                    <div className="left">
                      <Title>{t("common.notifi")}</Title>
                      <span>
                        {t("common.youHave")}{" "}
                        {listNoti &&
                        _.size(listNoti.filter((item) => !item.is_seen)) > 0
                          ? _.size(listNoti.filter((item) => !item.is_seen))
                          : "0"}{" "}
                        {t("common.unread")}
                      </span>
                    </div>
                    <div className="markRead" onClick={() => onMarkAllRead()}>
                      <Tooltip placement="top" title={"Mark all as read"}>
                        <img src={MarkRead} alt="icon" />
                      </Tooltip>
                    </div>
                  </WrapTitle>
                  <InfiniteScroll
                    scrollableTarget="popoverNoti"
                    dataLength={listNoti.length}
                    loader={<Spin />}
                    hasMore={hasMoreNoti}
                    next={() => loadMoreNoti()}
                  >
                    {listNoti &&
                      _.size(listNoti.filter((item) => !item.is_seen)) > 0 && (
                        <Label>{t("common.newNotifi")}</Label>
                      )}
                    {listNoti
                      .filter((item) => !item.is_seen)
                      .map((item, idx) => {
                        return (
                          <Noti
                            key={idx}
                            isSeen={item.is_seen}
                            onClick={() =>
                              onClickNoti(
                                item.content,
                                item.object_id,
                                item.record_id,
                                item._id,
                                item
                              )
                            }
                          >
                            <TextNoti>
                              {parse(item.content, optionsParse)}
                            </TextNoti>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <img src={Clock} alt="icon clock" />
                              <TimeNoti>{item.time}</TimeNoti>
                            </div>
                          </Noti>
                        );
                      })}
                    {listNoti &&
                      _.size(listNoti.filter((item) => !item.is_seen)) > 0 &&
                      _.size(listNoti.filter((item) => item.is_seen)) > 0 && (
                        <Label>{t("common.readNotifi")}</Label>
                      )}
                    {listNoti
                      .filter((item) => item.is_seen)
                      .map((item, idx) => {
                        return (
                          <Noti
                            key={idx}
                            isSeen={item.is_seen}
                            onClick={() =>
                              onClickNoti(
                                item.content,
                                item.object_id,
                                item.record_id,
                                item._id,
                                item
                              )
                            }
                          >
                            <TextNoti>
                              {parse(item.content, optionsParse)}
                            </TextNoti>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <img src={Clock} alt="icon clock" />
                              <TimeNoti>{item.time}</TimeNoti>
                            </div>
                          </Noti>
                        );
                      })}
                  </InfiniteScroll>
                  <Footter onClick={() => onOpenNotifications()}>
                    <div>View all</div>
                  </Footter>
                </EarlierNoti>
              )}
            </>
          )}
        </WrapperNoti>
      }
      id="popoverNoti"
      trigger="click"
      visible={showNoti}
      onVisibleChange={handleShowNoti}
      overlayClassName="popoverNoti"
      placement="bottomRight"
    >
      <NotiButton unseenNoti={unseenNoti > 0}>
        <NotificationIcon />
      </NotiButton>
    </Popover>
  );
}

export default NotificationVer3;

const Label = styled.div`
  padding: 8px 20px;
  color: #637381;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
`;

const Footter = styled.div`
  background-color: #fff;
  cursor: pointer;
  border-top: 1px solid #ccd4dd;
  height: 46px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    font-size: 14px;
    font-weight: 700;
    color: ${(props) => props.theme.main};
  }
`;

const WrapperNoti = styled.div`
  height: 100%;
  max-height: 720px !important;
  min-height: 200px !important;
  position: relative;

  .ant-spin {
    display: ${(props) => (props.isLoading ? "flex" : "unset")};
    justify-content: center;
    align-items: center;
    height: ${(props) => (props.isLoading ? "100%" : "unset")};
  }

  .ant-spin-dot-item {
    background-color: ${(props) => props.theme.main};
  }
`;

const EmptyNoti = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-height: 720px !important;
  min-height: 200px !important;
  font-size: 20px;
  font-family: var(--roboto-700);
`;

const WrapTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 16px 20px;
  position: sticky;
  top: 16px;
  z-index: 2;
  background: #fff;
  border-bottom: 1px solid #ccd4dd;

  .left {
    span {
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      color: #637381;
    }
  }

  .markRead {
    cursor: pointer;
    border-radius: 6px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s all ease;

    &:hover {
      background: #919eab29;
      transition: 0.2s all ease;
    }
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  color: #212b36;
`;

const EarlierNoti = styled.div`
  .infinite-scroll-component {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const Noti = styled.div`
  padding: 12px 20px;
  margin-bottom: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  background: ${(props) => (!props.isSeen ? "#20a2a229" : "unset")};

  background-color: ${(props) => {
    const hex = props.theme.main.replace(/^#/, "");
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return !props.isSeen ? `rgba(${r}, ${g}, ${b}, 0.15) !important` : "unset";
  }};

  &:hover {
    background: #f2f4f5;
    cursor: pointer;
  }
`;

const TextNoti = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  color: #252424;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;

  p {
    margin: 0;
    margin-bottom: 4px;
  }
`;

const TimeNoti = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #919eab;
`;

const NotiButton = styled.div`
  cursor: pointer;
  position: relative;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  :hover {
    background: #e8eaeb;
  }
  ::before {
    border-radius: 50%;
    display: ${(props) => (props.unseenNoti ? "block" : "none")};
    content: "";
    width: 12px;
    height: 12px;
    background: #ff5630;
    position: absolute;
    top: 6px;
    right: 10px;
  }
`;
